import React from 'react';
import './Step1Infos.css';

const Step1Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-1">
        La mappa mostra dov'è posizionato l’impianto fotovoltaico sul tetto e l’indirizzo della casa che lo ospita.<br />
        Puoi ingrandire e ridurre la mappa: fai clic sui pulsanti zoom ( + ) e ( - ) nell'angolo inferiore destro.<br />
        Se vuoi indicare una diversa posizione, clicca sulla mappa nel punto che desideri.
        </div>
    );
}

export default Step1Infos;